import mqtt from 'mqtt/dist/mqtt.min.js'

let client = null

/**
 * 连接MQTT
 * @param {String} userId 用户ID
 * @param {String} molv_token 作为 clientId
 * @param {Object} options 其他 mqtt 配置
 */
export function connectMqtt(userId, molv_token, options = {}) {
    if (client) return client

    const url = 'wss://api.yukevip.club/mqtt/'
    client = mqtt.connect(url, {
        clientId: molv_token,
        reconnectPeriod: 2000,
        ...options
    })

    client.on('connect', () => {
        // 管理后台订阅
        client.subscribe(`webAdmin/sub`, {qos: 0}, err => {
            if (!err) {
                console.log('【MQTT】webAdmin/sub 订阅成功')
            } else {
                console.error('【MQTT】订阅失败', err)
            }
        })
    })

    client.on('error', err => {
        console.error('【MQTT】连接错误', err)
    })

    client.on('reconnect', () => {
        console.log('【MQTT】正在重连...')
    })

    return client
}

export function getMqttClient() {
    return client
}

export function disconnectMqtt() {
    if (client) {
        client.end(true)
        client = null
    }
}
